import { render } from "./todoIndex.vue?vue&type=template&id=25f3c7bb"
import script from "./todoIndex.vue?vue&type=script&lang=js"
export * from "./todoIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__